import React from "react";
import UseTitle from "../components/useTitle";
import "./Page404.scss";

const Page404 = () => {
  // Définition du titre de la page
  UseTitle("404 - Page non trouvée");
  return (
    <div className="page-404">
      <h1>404 - Page non trouvée</h1>
      <p>Oops! La page que vous avez demandée ne semble pas exister</p>
    </div>
  );
};

export default Page404;
